/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Upload_TitleInputs */

const en_landing_studio_upload_title = /** @type {(inputs: Landing_Studio_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload the image to edit`)
};

const zh_landing_studio_upload_title = /** @type {(inputs: Landing_Studio_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传要编辑的图片`)
};

/**
* | output |
* | --- |
* | "Upload the image to edit" |
*
* @param {Landing_Studio_Upload_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_upload_title = /** @type {((inputs?: Landing_Studio_Upload_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Upload_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_upload_title(inputs)
	return zh_landing_studio_upload_title(inputs)
});
export { landing_studio_upload_title as "landing.studio.upload_title" }